import MenuItems from './MenuItems.js';
import { APP_DOMAIN_PREFIX } from '../../../environment/index.js';
import { useLocation, useNavigate } from "react-router-dom";
import '../scss/dropdown.scss';

const menuItems = [
    {
        title: 'HOME',
        url: '/home',
        sectionId: 'HOME'
    },
    {
        title: 'ABOUT',
        url: '',
        sectionId: 'ABOUT',
        // submenu: [
        //     {
        //         title: 'ABOUT-US',
        //         url: '/about-us',
        //     },
        //     {
        //         title: 'SUCESS STORIES',
        //         submenu: []
        //     },
        //     {
        //         title: 'SERVICES',
        //         submenu: []
        //     },
        //     {
        //       title:'PORTFOLIO',
        //       submenu:[]
        //     },
        //     {
        //       title:'WAPDA REGULATION',
        //       url:'/wapda-regulations'
        //     },
        //     {
        //         title: 'ORGANOGRAM',
        //         url: '/organo-page',
        //     }
        // ]
    },
    {
        title: 'SUCESS STORIES',
        url: '/',
        sectionId: 'SUCESS STORIES'
    },
    {
        title: 'SERVICES',
        url: '/',
        sectionId: 'SERVICES'
    },
    {
        title: 'PORTFOLIO',
        url: '/',
        sectionId: 'PORTFOLIO'
    },
    {
        title: 'CONTACT US',
        url: '/',
        sectionId: 'CONTACT US'
    },


];
const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleScroll = (id) => {
        if (location.pathname !== "/") {
            navigate("/", { state: { scrollTo: id } });
            return;
        }
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    

    return (
        <nav  className="navbar">
            <ul className="navbar-list">
                {
                    menuItems.map((menu, index) => {
                        const depthlevel = 0;
                        return <MenuItems items={menu} key={index} depthlevel={depthlevel} handleScroll={handleScroll} />
                    })
                }
            </ul>
        </nav>
    )
}

export default Navbar;